if (!customElements.get("subscribe-button")) {
  class SubscribeButton extends HTMLElement {
    constructor() {
      super();

      this.desktopForm = "SSbfvf";
      this.mobileForm = "RhnSQY";

      this.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("click");
        this.toggleForm();
      });
    }

    toggleForm() {
      window._klOnsite = window._klOnsite || [];
      if (window.innerWidth > 750) {
        window._klOnsite.push(["openForm", this.desktopForm]);
      } else {
        window._klOnsite.push(["openForm", this.mobileForm]);
      }
    }
  }
  customElements.define("subscribe-button", SubscribeButton);
}
